/* eslint-disable no-magic-numbers */

import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import wordFadeInGif from '../../../assets/images/transitions/wordFadeIn.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_WORD_FADE_OUT = 'wordFadeOut';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const wordFadeOutPresetDetails = {
  // The name of the preset.
  name: PRESET_WORD_FADE_OUT,

  // A preview of the transition.
  gif: wordFadeInGif,

  // A human friendly name for the preset.
  humanName: 'Word - Fade Out',

  // The element names that this preset can be used for or true for all elements.
  elements: ['text'],

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'out',

  // Each property that will change during the transition.
  details: {
    'word.opacity': {
      time: {
        end: 'end.-633',
        start: 'end.-1000'
      },
      easing: EASINGS.easeInPower4,
      values: [
        1,
        0
      ],
      stagger: '-100',
      immediateRender: false
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_WORD_FADE_OUT,
    options: {},
  },
};

wordFadeOutPresetDetails.template.options = lodash.cloneDeep(wordFadeOutPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_WORD_FADE_OUT;

// This defines the value of the presets object.
export default wordFadeOutPresetDetails;

